import { render, staticRenderFns } from "./Aviris3Tab.vue?vue&type=template&id=3243f8f3&scoped=true&"
import script from "./Aviris3Tab.vue?vue&type=script&lang=js&"
export * from "./Aviris3Tab.vue?vue&type=script&lang=js&"
import style0 from "./Aviris3Tab.vue?vue&type=style&index=0&id=3243f8f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3243f8f3",
  null
  
)

export default component.exports